/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Launch_Recent_TitleInputs */

const en_directory_launch_recent_title = /** @type {(inputs: Directory_Launch_Recent_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recent Launch Board`)
};

const zh_directory_launch_recent_title = /** @type {(inputs: Directory_Launch_Recent_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`近期工具榜`)
};

/**
* | output |
* | --- |
* | "Recent Launch Board" |
*
* @param {Directory_Launch_Recent_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_launch_recent_title = /** @type {((inputs?: Directory_Launch_Recent_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Launch_Recent_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_launch_recent_title(inputs)
	return zh_directory_launch_recent_title(inputs)
});
export { directory_launch_recent_title as "directory.launch.recent_title" }